import { TextField, Grid } from "@mui/material";
import { CustomerDetailData } from "../../interfaces/ICustomerDetails";

interface Shipment {
  id?: number;
  value?: string;
  label?: string;
  name?: string;
  multiline?: boolean;
  maxLength?: number;
  error?: boolean;
  type?: string;
  helperText?: string | number;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

interface ShipmentFieldsProps {
  shipments: Shipment[];
}

export const ShipmentCustomerDetails = ({ shipments }: ShipmentFieldsProps) => {
  return (
    <Grid container spacing={3}>
      {shipments?.map((shipment) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={shipment.id}>
          <TextField
            label={shipment.label}
            name={shipment.name}
            type={shipment.type}
            value={shipment.value}
            variant="standard"
            error={shipment.error}
            onChange={shipment.onChange}
            multiline={shipment.multiline}
            helperText={shipment.helperText}
            disabled={shipment.disabled}
            onFocus={shipment.onFocus}
          />
        </Grid>
      ))}
    </Grid>
  );
};
